export const Color = {
  Primary: '#fe706f',
  PrimaryBackground: '#f2f2f2',
  Accent: '#633c3c',
  AccentBackground: '#ffa39e',
  Background: '#fbfbfb',
};
